export default __webpack_public_path__ + "static/media/img2.fa895d08.png";